/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './status.module.scss';
import QuizStyles from '../../../Trainings/Quiz/quiz.module.scss';
import Modal from '../../../../components/modal/modal';
import icon from '../../../../icons/certificate.svg';
import downloadIcon from '../../../../icons/downloadIcon.svg';

const Certificate = (props) => {
  const {
    navigateToApplication,
    history, certificateUrl,
    savedApplications,
    userData,
    actionGetUserApplications,
    translation,
    unSuportedLanguage,
    suportedLanguages,
    quizAnswers,
    applicationDetails,
    isPortal,
    installationId } = props;
  let quiz_answers = useSelector(state => state?.permitManagement?.userData?.lms);
  const view_quiz_answer = useSelector(state => state?.permitManagement?.adpSchemaSettings?.settings?.view_quiz_answers);
  const suspendStatus = useSelector(state => state?.permitManagement?.userData?.suspended_details?.training_status || '');
  const [actionPopup, setActionPopup] = useState(false);
  const [adpQuizes, setAdpQuizes] = useState([]);
  const alphabet = 'ABCDEFGHIJK';

  const trainingData = [];
  let selectedLanguageTraining= [];
  if (unSuportedLanguage) {
    selectedLanguageTraining= quiz_answers?.English;
  }

  if (!unSuportedLanguage) {
    suportedLanguages.forEach((ele) => {
      if (ele.name===JSON.parse(localStorage.getItem('adpLanguage')).name) {
        const name=`${ele.name.slice(0, 1).toUpperCase()}${ele.name.slice(1)}`;
        selectedLanguageTraining= quiz_answers?.[name]? quiz_answers?.[name] : quiz_answers?.English;
      }
    });
  }

  if (selectedLanguageTraining?.sections) {
    selectedLanguageTraining.sections.forEach((ele) => {
      ele.contents.forEach((el) => {
        trainingData.push(el);
      });
    });
  }
  useEffect(() => {
      setAdpQuizes(trainingData[trainingData.length - 1]?.schema?.fields);
  }, [trainingData]);

  const handleActionPopup = () => {
    setActionPopup(!actionPopup);
  };

  const handleBackApplications = () => {
    if (isPortal) {
      localStorage.removeItem(applicationDetails.id);
      history.push('/adp/myapplications');
    } else {
      const index = savedApplications?.findIndex(app => app.key===userData?.key);
      if (index > -1) {
        savedApplications[index].suspended_training_status=userData?.suspended_details?.training_status;
        actionGetUserApplications(savedApplications);
      }
      localStorage.setItem('current_page', 'userApplications');
      history.push(`/auth/adp/login/${installationId}`);
    }
  };

  return (
  <div className={styles.certificateContainer}>
    <div className={styles.imgContainer}>
      <img src={icon} alt="certificate" className={styles.certificateImg} />
    </div>
    <h3 className={styles.h3}>
      {translation.congratulations}
      !
    </h3>
    <p className={styles.p}>
      {translation.pass}
      .
    </p>
    <a color="inherit" href={certificateUrl} download>
      <div className={styles.downloadeButton}>
        <p style={{ fontSize: 'bold', margin: 0 }}>{translation.download_certificate}</p>
        <img src={downloadIcon} alt="download" />
      </div>
    </a>
    {((suspendStatus?.length === 0 && suspendStatus !== 'Pending' && ((applicationDetails?.status !== 3 && applicationDetails?.status !== 8)))
    || (applicationDetails?.status !== 3 && applicationDetails?.status !== 8))
      ? (
        <div className={styles.applicationeButton} role="button" tabIndex={0} onClick={() => { navigateToApplication(); }} onKeyDown="">
          <p style={{ fontSize: 'bold', margin: 0 }}>{translation.start_application}</p>
        </div>
      )
      : (
        <div
          className={styles.applicationeButton}
          role="button"
          tabIndex={0}
          onClick={() => handleBackApplications()}
          onKeyDown={() => handleBackApplications()}>
            <p style={{ fontSize: 'bold', margin: 0 }}>Back to Applications</p>
        </div>
      )
    }
    {view_quiz_answer === true
      && (
      <div className={styles.applicationeButton} role="button" tabIndex={0} onClick={() => handleActionPopup()} onKeyDown="">
        <p style={{ fontSize: 'bold', margin: 0 }}>View Answers</p>
      </div>
      )
    }
    <Modal
      showIn={actionPopup}
      onClose={() => setActionPopup(false)}
      width="50%"
      contentStyles={{
        overflow: 'auto',
        padding: '20px 40px',
        height: '60%'
      }}
    >
    {adpQuizes?.map((ele, i) => (
    <div className={QuizStyles.adpChalangeContainer} key={ele.title} style={{ width: '100%' }}>
      <h4 className={QuizStyles.questionText}>
        {translation.question}
        {' '}
        {i + 1}
      </h4>
      <h4 style={{ fontSize: '20px', fontWeight: 500 }}>
        {ele.title}
      </h4>
      {ele.values.map((opt, index) => (
      <div className={QuizStyles.optionContainer} key={opt.key}>
        <h3 style={{ backgroundColor:
        opt.correct_answer && quizAnswers?.[ele.id]?.includes(opt.value) ? 'green'
         : quizAnswers?.[ele.id]?.includes(opt.value) ? 'red' : '',
          border: '1px grey solid',
          color: 'black',
          padding: '3px 7px',
          fontSize: '18px',
          borderRadius: '3px' }}>
            {alphabet[index]}
        </h3>
        <p style={{ color: opt.correct_answer && quizAnswers?.[ele.id]?.includes(opt.value)
        ? 'green' : quizAnswers?.[ele.id]?.includes(opt.value) ? 'red' : '',
        fontSize: '18px' }}>
          {opt.value}
        </p>
      </div>
      ))}
    </div>
      ))}
    </Modal>
  </div>
  );
};

export default Certificate;
